import React, { useState, useEffect } from 'react';
import { Tabs, Switch, message, Popconfirm, Button } from 'antd';
import { useParams } from 'react-router-dom';
import { DashboardOutlined, UserOutlined, KeyOutlined, CopyOutlined, CloudOutlined, AppstoreOutlined, DollarOutlined } from '@ant-design/icons';
import axios from 'axios';
import OrgDashboard from '../components/OrgDashboard ';
import OrgUsers from '../components/OrgUserTab';
import OrgApiKeys from '../components/OrgApiKeys';
import { IconArrowLeft } from '@tabler/icons-react';
import OrgProviders from '../components/OrgProviders';
import OrgModels from '../components/OrgModels';
import OrgSetting from '../components/OrgSetting';
import OrgConfigurables from '../components/OrgConfigurables';
// import AppMenu from '../components/AppMenu';
// import Invoices from '../components/OrgInvoices';

const { TabPane } = Tabs;

const OrganizationView = () => {
  const { orgId } = useParams(); // Get the organization ID from the URL
  const [organization, setOrganization] = useState(null); // State to store organization data
  const [loading, setLoading] = useState(true); // State to manage loading
  const [activeTab, setActiveTab] = useState('1'); // Track the active tab

  useEffect(() => {
    // Fetch organization details when the component mounts
    const fetchOrganization = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API}/api/organizations/${orgId}`);
        setOrganization(response.data); // Set the organization data
        setLoading(false);
      } catch (error) {
        console.error('Error fetching organization data:', error);
        setLoading(false); // Stop loading on error
      }
    };

    fetchOrganization();
  }, [orgId]);


  // Function to copy orgSecret to the clipboard
  const copySecretKey = () => {
    if (organization && organization.orgSecret) {
      navigator.clipboard.writeText(organization.orgSecret).then(() => {
        message.success('Secret key copied to clipboard!');
      }).catch(err => {
        console.error('Failed to copy: ', err);
        message.error('Failed to copy secret key.');
      });
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!organization) {
    return <div>Error: Organization not found</div>;
  }

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  return (
    <div style={{ padding: '20px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "10px" }}>
            <IconArrowLeft onClick={() => window.location.replace("/organization")} stroke={1} color='white' style={{ cursor: "pointer" }} />
            <h1 style={{ color: 'white' }}>Organization - {organization.name}</h1></div>

          {organization?.orgSecret ? <Button icon={<CopyOutlined />} onClick={copySecretKey} type="link">
            Copy Secret Key
          </Button> : <span style={{ color: 'white' }}>Key Not Found</span>}

        </div>

      </div>

      <Tabs defaultActiveKey="1" type="card" style={{ marginTop: '20px' }} onChange={handleTabChange}>
        <TabPane tab={<span><DashboardOutlined /> Dashboard</span>} key="1">
          {activeTab === '1' && <OrgDashboard />}
        </TabPane>
        <TabPane tab={<span><UserOutlined /> Users</span>} key="2">
          {activeTab === '2' && <OrgUsers />}
        </TabPane>
        <TabPane tab={<span><KeyOutlined /> API Keys</span>} key="3">
          {activeTab === '3' && <OrgApiKeys />}
        </TabPane>
        <TabPane tab={<span><CloudOutlined /> Providers</span>} key="4">
          {activeTab === '4' && <OrgProviders />}
        </TabPane>
        <TabPane tab={<span><AppstoreOutlined /> Models</span>} key="5">
          {activeTab === '5' && <OrgModels />}
        </TabPane>

        <TabPane tab={<span><AppstoreOutlined /> Setting</span>} key="7">
          {activeTab === '7' && <OrgSetting />}
        </TabPane>

        <TabPane tab={<span><AppstoreOutlined /> Configurables</span>} key="8">
          {activeTab === '8' && <OrgConfigurables orgId={orgId} />}
        </TabPane>
      </Tabs>
    </div>
  );
};

export default OrganizationView;
